import { render, staticRenderFns } from "./InvestorPlanInfo.vue?vue&type=template&id=0248ce59&scoped=true&"
import script from "./InvestorPlanInfo.vue?vue&type=script&lang=js&"
export * from "./InvestorPlanInfo.vue?vue&type=script&lang=js&"
import style0 from "./InvestorPlanInfo.vue?vue&type=style&index=0&id=0248ce59&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0248ce59",
  null
  
)

export default component.exports